import React, { ReactElement } from 'react'
import { Provider } from 'react-redux'
import { Store } from 'redux'

export interface IProviderProps {
  children: ReactElement
  store: Store
}
const ProviderWrapper = (props: IProviderProps): ReactElement => {
  const { children, store } = props
  return <Provider store={store}>{children}</Provider>
}

export default ProviderWrapper
